import { RouteResolver } from './RouteResolver';

export default RouteResolver;
